/**
 * Script origins that are never ours (#4630). Passed to Sentry `denyUrls`, which drops an event whose TOP stack frame
 * comes from a matching script. OfficeHub's own bundle is served from https://<site>.web.app / our domains, so none of
 * these can match first-party code.
 *
 * DELIBERATELY NOT `app://`: a native wrapper (the tech app's bridge) serves first-party code from an `app://` origin,
 * and a blanket match would hide real crashes. Only the one browser-extension path observed in the sibling product
 * (`app:///executors/`) is named.
 *
 * Every entry is anchored to a scheme or path segment; the test pins a first-party URL for each that must NOT match.
 */
export const FOREIGN_SCRIPT_DENY_URLS: readonly RegExp[] = [
  /^chrome-extension:\/\//i,
  /^moz-extension:\/\//i,
  /^safari-(?:web-)?extension:\/\//i,
  /^app:\/\/\/executors\//i,
  /^https?:\/\/[^/]+\/_vercel\/insights\//i,
];
